import styled from "styled-components"

interface HighlightProps {
  ignoreMinHeight?: boolean
}

export default styled.div<HighlightProps>`
  margin: 0;
  padding: 0;
  display: inline-flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
  min-height: ${({ignoreMinHeight, theme}) => (ignoreMinHeight ? "auto" : theme.spacing.eight)};
`
